module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/xK884a/tc-custom/9780547542799.jpg?1700825471439",
      "alt": "This image is the cover for the book Night Flight"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Night Flight\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Fasten your seatbelt to experience the spectacle and solitude of flying high in the Andes in this novel from the author of "), _c('i', [_vm._v("The Little Prince")]), _vm._v(".")])]), _c('p', [_vm._v("No writer has equaled Saint-Exupéry in describing the perilous and poetic experience of flying, in submission to what he calls “those damn elemental divinities—night, day, mountain, sea and storm.” In this gripping, beautifully written novel inspired by his experience as a pilot in South America, he tells of the brave men who pilot night mail planes from Patagonia, Chile, and Paraguay to Argentina in the early days of commercial aviation. They are impelled to perform their routine acts of heroism by a steely chief named Rivière, whose extraordinary character is revealed through the dramatic events of a single night.")]), _c('p', [_c('b', [_vm._v("Preface by André Gide. Translated by Stuart Gilbert.")])]), _c('b', [_vm._v("“The book stands out by reason of the quality of its style, the beauty of the passages in which flight is described better than it ever has been before, but more especially because of the emotions of the men of heroic mold.”—André Maurois, "), _c('i', [_vm._v("Saturday Review")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Antoine de Saint-Exupéry\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Houghton Mifflin Harcourt (hmhbooks.com)\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0